import { createFileRoute } from "@tanstack/react-router";

import { AdminAutomation } from "@/features/admin";

/**
 * Admin Automation — wire path ``/admin/automation``.
 *
 * v1 reference: ``app/admin-v2/components/pages/AutomationPage.tsx`` (125 LoC).
 * BE: ``GET /admin/v2/automation`` (``admin_v2.py:630``).
 */
export const Route = createFileRoute("/_authed/_modal/admin/automation")({
  component: AdminAutomation,
});
